import * as React from 'react';
import { FC, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import StyledTable from '../../../components/StyledTable';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { getAdminEasypayCommissionsAsync } from '../../../ajax/requests';

const METHOD_LOGO: Record<string, string | undefined> = {
    MBWay: 'MBWAY',
    RefMB: 'MULTIBANCO',
    CreditCard: 'CREDIT-CARD',
    DigitalIBAN: 'DIGITAL-IBAN',
    GooglePay: 'GOOGLE-PAY',
    ApplePay: 'APPLE-PAY',
    SamsungWallet: 'SAMSUNG-PAY',
}

const METHOD_LABEL: Record<string, string | undefined> = {
    MBWay: 'MB Way',
    RefMB: 'Multibanco',
    CreditCard: 'Credit Card',
    DigitalIBAN: 'Digital IBAN',
    DirectDebit: 'Direct Debit',
    GooglePay: 'Google Pay',
    ApplePay: 'Apple Pay',
    SamsungWallet: 'Samsung Pay',
    None: 'Checkout',
}

interface EasypayCommissionsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const EasypayCommissionsModal: FC<EasypayCommissionsModalProps> = ({ isOpen, onClose }) => {
    const t = useTranslations()
    const [commissions, setCommissions] = React.useState<Record<string, { percentage: number; fixed: number }> | null>(null)

    React.useEffect(() => {
        if (isOpen && !commissions) {
            getAdminEasypayCommissionsAsync().then(setCommissions)
        }
    }, [isOpen])

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>{t(TK.easypayCommissionsTitle)}</ModalHeader>
            <ModalBody>
                <StyledTable hover striped>
                    <thead>
                        <tr>
                            <th>{t(TK.paymentType)}</th>
                            <th style={{textAlign: 'right'}}>{t(TK.easypayCommissionPercentage)}</th>
                            <th style={{textAlign: 'right'}}>{t(TK.easypayCommissionFixed)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {commissions && Object.entries(commissions).map(([method, c]) => {
                            const logo = METHOD_LOGO[method]
                            return (
                                <tr key={method}>
                                    <td style={{display: 'flex', alignItems: 'center', gap: 'var(--spacer-XS)'}}>
                                        {logo
                                            ? <img src={`/payment-methods/${logo}.svg`} alt={method} style={{height: '24px', width: 'auto'}} />
                                            : (METHOD_LABEL[method] ?? method)}
                                    </td>
                                    <td style={{textAlign: 'right'}}>{(c.percentage * 100).toFixed(2)}%</td>
                                    <td style={{textAlign: 'right'}}>{c.fixed.toFixed(2)}€</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </StyledTable>
                <p style={{marginTop: 'var(--spacer-S)', marginBottom: 0, fontSize: '0.85em', color: 'var(--text-muted)'}}>
                    {t(TK.easypayOfficialPricingNote)}{' '}
                    <a href="https://www.easypay.pt/precos/" target="_blank" rel="noopener noreferrer">easypay.pt/precos</a>
                </p>
            </ModalBody>
        </Modal>
    )
}

export default EasypayCommissionsModal;
